import { render, staticRenderFns } from "./components.user-interest.vue?vue&type=template&id=c553d1cc"
import script from "./components.user-interest.vue?vue&type=script&lang=js"
export * from "./components.user-interest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports